<template>
    <div>
        <layout-wrapper>
            <div>
                Follow Up
                <!-- <v-btn class="text-white pull-right btn btn-primary" @click="dialog = !dialog">
                    Sinkron Gambar
                </v-btn> -->
            </div>
            <div class="clearfix"></div>
            <br>
            <div class="wrapp-input-contact m-t-20">
                <template>
                    <div class="list-auto-template">
                        <v-row>
                            <v-col cols="1"></v-col>
                            <v-col cols="2" class="text-center">
                                <v-card outlined elevation="2">
                                    <v-card-text style="font-weight: bold;">
                                        <div>
                                            <v-icon sm class="mr-1" color="error">mdi-checkbox-blank-circle</v-icon>
                                            <span>OVERDUE</span>
                                        </div>
                                        <div>{{ summary.overdue || 0 }}</div>
                                        <div>Need Action</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="2" class="text-center">
                                <v-card outlined elevation="2">
                                    <v-card-text style="font-weight: bold;">
                                        <div>
                                            <v-icon sm class="mr-1" color="warning">mdi-checkbox-blank-circle</v-icon>
                                            <span>TODAY</span>
                                        </div>
                                        <div>{{ summary.today || 0 }}</div>
                                        <div>Today</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="2" class="text-center">
                                <v-card outlined elevation="2">
                                    <v-card-text style="font-weight: bold;">
                                        <div>
                                            <v-icon sm class="mr-1" color="primary">mdi-checkbox-blank-circle</v-icon>
                                            <span>UPCOMING</span>
                                        </div>
                                        <div>{{ summary.upcoming || 0 }}</div>
                                        <div>Next 7 days</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="2" class="text-center">
                                <v-card outlined elevation="2">
                                    <v-card-text style="font-weight: bold;">
                                        <div>
                                            <v-icon sm class="mr-1" color="success">mdi-checkbox-blank-circle</v-icon>
                                            <span>POTENTIAL</span>
                                        </div>
                                        <div>{{ summary.potential }}</div>
                                        <div>Customers</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="2" class="text-center">
                                <v-card outlined elevation="2">
                                    <v-card-text style="font-weight: bold;">
                                        <div>
                                            <v-icon sm class="mr-1" color="warning">mdi-coin</v-icon>
                                            <span>Won</span>
                                        </div>
                                        <div>{{ summary.won }}</div>
                                        <div>This months</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="1"></v-col>
                        </v-row>
                        <v-divider class="my-8"></v-divider>
                        <v-row>
                            <v-col cols="12" class="col col-md-3 pt-0">
                                <v-text-field v-model="customerName" placeholder="Search Customer"></v-text-field>
                            </v-col>
                            <v-col cols="12" class="col col-md-3 pt-0">
                                <v-autocomplete hide-selected 
                                    class="mb-0"
                                    label="Operator"
                                    item-text="name"
                                    item-value="_id"
                                    v-model="selectedOperatorId"
                                    :items="operatorList" 
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" class="col col-md-3 pt-0">
                                <v-select label="Channel"
                                    item-text="text"
                                    item-value="value"
                                    v-model="selectedChannel"
                                    :items="channels" 
                                ></v-select>
                            </v-col>
                            <v-col cols="3" class="pt-0-mobile mb-4">
                                <v-btn class="mt-2-mobile mr-2 text-white btn btn-primary" @click="handleSearch">
                                    Cari
                                </v-btn>
                                <v-btn @click="resetFilter" class="mt-2-mobile">
                                    Reset
                                </v-btn>
                            </v-col>
                        </v-row>

                        <div class="my-5">
                            <v-row class="mb-2">
                                <v-col>
                                    <v-btn class="text-white btn btn-primary" @click="checkNeedFollowUp()">
                                        Cek Follow Up
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-data-table class="elevation-1"
                                :headers="headers" 
                                :items="contacts" 
                                :options.sync="options"
                                :server-items-length="totalElements"
                                :loading="isLoading"
                                :footer-props="{ 'items-per-page-options': [5, 10, 15] }"
                            >   
                                <template v-slot:item.customer="{ item }">
                                    <div>
                                        <div class="mb-2">
                                            <v-icon>mdi-account</v-icon>
                                            <div>{{ item.name }}</div>
                                            <div>{{ item.primaryPhoneNumber }}</div>
                                        </div>
                                        <div class="mb-2">
                                            <v-icon>mdi-account-key</v-icon>
                                            <div>{{ item.currentOperatorName }}</div>
                                        </div>
                                        <div>
                                            <v-btn v-if="item.followUpHistory.result == null || item.followUpHistory.result == false" rounded dark 
                                                class="ma-2" 
                                                color="red"
                                                @click="item.followUpHistory.result == null 
                                                    ? OpenConfirmDialog(item, false)
                                                    : ''"
                                            >
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                            <v-btn v-if="item.followUpHistory.result == null || item.followUpHistory.result == true" rounded dark 
                                                class="ma-2" 
                                                color="success"
                                                @click="item.followUpHistory.result == null 
                                                    ? OpenConfirmDialog(item, true) 
                                                    : ''"
                                            >
                                                <v-icon>mdi-check</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:item.lastMessagesText="{ item }">
                                    <div>
                                        <div>{{ item.lastActiveUI }}</div>
                                        <div>"{{ item.lastMessagesTextUI }}"</div>
                                    </div>
                                </template>
                                <template v-slot:item.followUpDate="{ item }">
                                    <div v-if="item.followUpTime">
                                        <div>{{ item.followUpTime }}</div>
                                        <div>
                                            <v-icon class="mr-1">mdi-calendar</v-icon>
                                            <span>{{ item.followUpDate }}</span>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <div>
                                        <v-menu offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon small dark v-bind="attrs" v-on="on"
                                                    color="primary"
                                                    elevation="2"
                                                >
                                                    <v-icon>mdi-dots-vertical</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-item @click="goToPage(item)">
                                                    <v-list-item-icon>
                                                        <v-icon>mdi-message-processing</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                        <v-list-item-title>Send Message</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-list-item @click="OpenDialog(item)">
                                                    <v-list-item-icon>
                                                        <v-icon>mdi-calendar-range</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                        <v-list-item-title>Schedule Follow Up</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-list-item v-if="item.label != selectedLabels[selectedLabels.length - 1]"
                                                    @click="updateLabel(item)">
                                                    <v-list-item-icon>
                                                        <v-icon>mdi-skip-next</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                        <v-list-item-title>Move Stage</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </div>
                                </template>
                            </v-data-table>
                        </div>
                    </div>
                </template>
            </div>
        </layout-wrapper>
  
        <v-dialog v-model="dialog" persistent max-width="600px">
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Open Dialog
                </v-btn>
            </template>
            <v-card>
                <v-card-title>
                    <span class="text-h5">Update Schedule Follow Up</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <v-date-picker v-model="pickerDate"></v-date-picker>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-time-picker format="24hr" v-model="pickerTime"></v-time-picker>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="blue darken-1" @click="resetDialog()">
                        Batal
                    </v-btn>
                    <v-btn text color="blue darken-1" @click="updateContactSchedule()">
                        Simpan
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogConfrim" max-width="400">
            <v-card>
                <v-card-title class="text-h6">
                    Konfirmasi
                </v-card-title>
                <v-card-text>
                    Apakah Anda yakin ingin mengubah data ini?
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogConfrim = false">
                        Batal
                    </v-btn>
                    <v-btn color="primary" depressed @click="updateContactIsWon(isWon, selectedCustomerId)">
                        Simpan
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import axios from 'axios'
    import Scrollbar from 'smooth-scrollbar'
    import Toast from '../plugins/vuenotification.js'
    import { mapState, mapActions } from 'vuex'
    
    import MainLayout from "../layouts/MainLayout"
    import LayoutWrapper from '../layouts/components/LayoutWrapper.vue'

    const { commonpagesetup, mainuisetup } = require('../utils/ui-setup/index.js')
    var moment = require('moment');

    export default {
        computed: {
            ...mapState({
                sessionInfo: state => state.session.sessionInfo,
                operatorList: state => state.operator.operatorList,
                labels: state => state.select.labels,
            })
        },
        data: function () {
            return {
                totalElements: 0,

                customerName: String(),
                selectedCustomerId: String(),
                selectedOperatorId: String(),
                selectedChannel: String(),
                pickerDate: String(),
                pickerTime: String(),

                headers: [
                    { text: 'Customer', value: 'customer', sortable: false },
                    { text: 'Last Chat', value: 'lastMessagesText', width: '300px', sortable: false },
                    { text: 'Stage', value: 'label', sortable: false },
                    { text: 'Next Follow Up', value: 'followUpDate', sortable: false },
                    { text: 'Action', value: 'action', sortable: false },
                ],

                contacts: Array(),
                selectedLabels: Array(),

                channels: [
                    { text: "Semua", value: "" },
                    { text: "Whatsapp", value: "WA" },
                    { text: "Facebook", value: "FB" },
                    { text: "Instagram", value: "IG" }
                ],
                
                options: Object(),
                summary: Object(),

                isLoading: false,
                isWon: false,
                dialog: false,
                dialogConfrim: false,
            }
        },
        watch: {
            options: {
                handler() {
                    this.loadSync();
                },
                deep: true,
            },
            sessionInfo: function (val) {
                if (!this.$helpers.isBlank(val) && val.isLoggedIn) {
                    this.loadInitialData();
                }
            },
        },
        methods: {
            ...mapActions({
                initOperatorList: 'operator/initOperatorList'
            }),

            handleSearch: async function() {
                this.options.page = 1
                await this.loadSync()
            },

            resetFilter: async function() {
                this.customerName = String()
                this.selectedOperatorId = String()
                this.selectedChannel = String()

                await this.loadSync()
            },

            resetDialog: async function() {
                this.dialog = false
                this.selectedCustomerId = String()
                this.pickerDate = String()
                this.pickerTime = String()
            },

            OpenDialog: async function(item) {
                this.dialog = true
                this.selectedCustomerId = item.id
            },

            OpenConfirmDialog: async function(item, isWon) {
                this.dialogConfrim = true
                this.selectedCustomerId = item.id
                this.isWon = isWon
            },

            loadInitialData: async function () {
                this.loadSync()
            },

            goToPage: function(item) {
                const queryParams = {
                    status: 'open', 
                    sortOrder: 'lastActive', 
                    sortDir: 'desc', 
                    labels: '', 
                    custroles: '', 
                    lastMessagesDirection: '', 
                    stars: 'false', 
                    operatorId: '', 
                    channel: ''
                }

                if(this.sessionInfo.userId == item.currentOperatorId) {
                    this.$router.push({
                        name: 'myconversation',
                        params: { id: encodeURIComponent(item.id) },
                        query: queryParams
                    });
                } else {
                    this.$router.push({
                        name: 'allmessage',
                        params: { id: encodeURIComponent(item.id) },
                        query: queryParams
                    });
                }
            },

            loadSync: async function() {
                this.isLoading = true

                try {
                    let params = {
                        page: this.options.page,
                        size: this.options.itemsPerPage,
                        sort: "scheduleTime",
                        sortDir: "desc",
                        term: this.customerName,
                        status: "open",
                        labels: "",
                        custroles: "",
                        lastMessagesDirection: "",
                        stars: false,
                        operatorId: this.selectedOperatorId,
                        contactChannel: this.selectedChannel,
                        isFollowUp: true
                    };

                    const { data } = await axios.get(process.env.VUE_APP_API_URL + '/contact/listallmessage', {
                        params
                    })

                    this.contacts = data.content.map((e) => {
                        const selectedFlow = e.followUpHistory.flows[e.followUpHistory.flows.length - 1]

                        let date = null

                        if(selectedFlow.startOn) {
                            date = moment(selectedFlow.startOn)
                        }

                        e.lastActiveUI = this.timeAgo(e.lastActive)
                        e.lastMessagesTextUI = e.lastMessagesText
                        e.followUpDate = date != null ? date.format('ll') : "";
                        e.followUpTime = date != null ? this.formatDateInfo(date) : "";

                        if(e.lastMessagesText.length > 230) {
                            e.lastMessagesTextUI = e.lastMessagesText.substring(0, 230) + " ..."
                        }

                        e.label = e.followUpHistory.currentLabel

                        return e
                    })
                    this.totalElements = data.page.totalElements

                    this.loadSummary()

                } catch (error) {
                    console.log("load-sync", error);

                    if(error.response) {
                        Toast.showToast("error", error.response.data.message)
                    } else {
                        Toast.showToast("error", error.message)
                    }
                }

                this.isLoading = false
            },

            loadSummary: async function() {
                try {
                    const { data } = await axios.get(process.env.VUE_APP_API_URL + '/contact/follow-up/summary')

                    this.summary = data
                } catch (error) {
                    console.log("load-summary", error);

                    if(error.response) {
                        Toast.showToast("error", error.response.data.message)
                    } else {
                        Toast.showToast("error", error.message)
                    }
                }
            },

            checkNeedFollowUp: async function() {
                try {
                    const params = {
                        formalIds: String(),
                        dateType: String(),
                        creationTime: String(),
                        status: String(),
                        paymentStatus: String(),
                        shipmentStatus: String(),
                        customerId: String(),
                        page: 0,
                        size: 1,
                        sort: "creationTime,DESC"
                    }

                    const noFollowUp = []
                    const needFollowUp = []

                    for (let i = 0; i < this.contacts.length; i++) {
                        const element = this.contacts[i];

                        params.customerId = element.id

                        const { data } = await axios.get(process.env.VUE_APP_API_URL + '/cmrc/sales-order', {
                            params
                        })
    
                        if(data.numberOfElements >= 1 && element.followUpHistory.flows.length > 1) {
                            const order = data.content[0]
    
                            const index = this.selectedLabels.findIndex((e) => e == element.followUpHistory.currentLabel)
    
                            const beforeFlow = element.followUpHistory.flows[index - 1]
                            const currentFlow = element.followUpHistory.flows[index]
    
                            const isBetween = moment(order.creationTime).isBetween(beforeFlow.endOn, currentFlow.startOn)
    
                            if(isBetween) {
                                noFollowUp.push(element.name)

                                try {
                                    const body = { 
                                        isWon: true,
                                        datetime: moment()
                                    }
                                    
                                    await axios.put(process.env.VUE_APP_API_URL + '/contact/follow-up/' + element.id, body)
                                } catch (error) {
                                    console.log("error", error)
                                }
                            } else {
                                needFollowUp.push(element.name)
                            }
                        }
                    }

                    await this.loadSync()

                    Toast.showToast("success", `Kontak ini sudah di selesaikan: ${noFollowUp.join(', ')}`)
                } catch (error) {
                    console.log("check-need-follow-up", error);

                    if(error.response) {
                        Toast.showToast("error", error.response.data.message)
                    } else {
                        Toast.showToast("error", error.message)
                    }
                }
            },

            updateContactSchedule: async function() {
                this.isLoading = true

                try {
                    const body = {
                        datetime: moment(`${this.pickerDate} ${this.pickerTime}`, "YYYY-MM-DD HH:mm").toDate()
                    }
                    
                    await axios.put(process.env.VUE_APP_API_URL + '/contact/follow-up/' + this.selectedCustomerId, body)

                    this.resetDialog()

                    Toast.showToast("success", "Berhasil mengubah schedule")

                    this.loadSync()
                } catch (error) {
                    console.log("update-contact-schedule", error);

                    if(error.response) {
                        Toast.showToast("error", error.response.data.message)
                    } else {
                        Toast.showToast("error", error.message)
                    }
                }

                this.isLoading = false
            },

            updateContactIsWon: async function(isWon, customerId) {
                this.isLoading = true

                try {
                    const body = { 
                        isWon: isWon,
                        datetime: moment()
                    }
                    
                    await axios.put(process.env.VUE_APP_API_URL + '/contact/follow-up/' + customerId, body)

                    this.dialogConfrim = false

                    Toast.showToast("success", "Berhasil mengubah data")

                    this.loadSync()
                } catch (error) {
                    console.log("update-contact-schedule", error);

                    if(error.response) {
                        Toast.showToast("error", error.response.data.message)
                    } else {
                        Toast.showToast("error", error.message)
                    }
                }

                this.isLoading = false
            },

            updateLabel: async function(item) {
                this.isLoading = true

                try {
                    const list = this.selectedLabels

                    const index = list.findIndex((e) => e == item.label)

                    let label = "";

                    if(index >= 0) {
                        label = this.selectedLabels[index + 1]
                    }

                    const body = {
                        "labels": [
                            ...item.labels.filter((e) => e != item.label),
                            label
                        ],
                        datetime: moment()
                    }
                    
                    await axios.put(process.env.VUE_APP_API_URL + '/contact/label/' + item.id, body)

                    Toast.showToast("success", "Berhasil mengubah data")

                    this.loadSync()
                } catch (error) {
                    console.log("update-contact-schedule", error);

                    if(error.response) {
                        Toast.showToast("error", error.response.data.message)
                    } else {
                        Toast.showToast("error", error.message)
                    }
                }

                this.isLoading = false
            },

            removeSelected: function(item, type) {
                if(type == 'role') {
                    const index = this.customFilterUiFlag.custroles.indexOf(item.id)
                    if (index >= 0) this.customFilterUiFlag.custroles.splice(index, 1)
                } else {
                    const index = this.selectedLabels.indexOf(item)
                    if (index >= 0) this.selectedLabels.splice(index, 1)
                }
            },

            timeAgo: function(date) {
                const now = moment();
                const target = moment(date);

                const minutes = now.diff(target, "minutes");
                const hours = now.diff(target, "hours");
                const days = now.diff(target, "days");

                if (minutes < 1) {
                    return "Just now";
                }

                if (minutes < 60) {
                    return `${minutes} minutes ago`;
                }

                if (hours < 24) {
                    return `${hours} hours ago`;
                }

                if (days === 1) {
                    return "Yesterday";
                }

                return `${days} days ago`;
            },

            formatDateInfo: function(date) {
                const target = moment(date);
                const now = moment();

                // Sudah lewat
                if (target.isBefore(now)) {
                    const days = now.startOf('day').diff(target.clone().startOf('day'), 'days');

                    if (days === 0) {
                    return `Overdue today ${target.format('HH:mm')}`;
                    }

                    return `Overdue ${days} ${days === 1 ? 'day' : 'days'}`;
                }

                // Hari ini
                if (target.isSame(now, 'day')) {
                    return `Today ${target.format('HH:mm')}`;
                }

                // Besok
                if (target.isSame(now.clone().add(1, 'day'), 'day')) {
                    return `Tomorrow ${target.format('HH:mm')}`;
                }

                // Tanggal lainnya
                return target.format('MMM DD, HH:mm');
            },

            utcToLocal: function(date, format) {
                var utcLocal = moment(date).local().format(format);
                return utcLocal;
            },

            utcToLocalView: function(date, format) {
                var utcLocal = moment(date).format(format);
                return utcLocal;
            },

            localToUtc: function(date, format) {
                var utcLocal = moment(date).utc().format(format);
                return utcLocal;
            },
        },
        created: function () {
            this.$emit('update:layout', MainLayout);
        },
        mounted: function () {
            Scrollbar.initAll();

            // if (!this.$helpers.isBlank(this.sessionInfo) && this.sessionInfo.isLoggedIn) {
            //     this.loadInitialData();
            // }

            const labels = process.env.VUE_APP_FOLLOW_UP_LIST || ""

            this.selectedLabels = labels.split(",")

            try {
                mainuisetup();
                commonpagesetup();
                this.initOperatorList()
            } catch (err) {
                console.log(err);
            }
        },
        components: {
            'layout-wrapper': LayoutWrapper
        }
    }
</script>